import DownloadIcon from '@mui/icons-material/Download';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import StarIcon from '@mui/icons-material/Star';
import { AppBar, Button, IconButton, Link, Toolbar, Typography } from '@mui/material';

const NavBar = () => {
  return (
    <AppBar position="static" elevation={1}>
      <Toolbar>
        <IconButton edge="start" color="primary" sx={{ mr: 2 }}>
          <StarIcon fontSize="large" />
        </IconButton>
        <Typography variant="h6" color="inherit" sx={{ flexGrow: 1 }}>
          Street Ratings
        </Typography>
        <Button color="inherit" startIcon={<HomeIcon />} component={Link} href="/">
          Home
        </Button>
        <Button
          color="inherit"
          startIcon={<DownloadIcon />}
          component={Link}
          href="https://play.google.com/store/apps/details?id=com.geekmotors.streetratings"
          target="_blank"
          rel="noopener"
        >
          Download
        </Button>
        <Button color="inherit" startIcon={<InfoIcon />} component={Link} href="/about">
          About
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export { NavBar };
